import { CopyIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Copy = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <CopyIcon size={Sizes[size]} color={fill || stroke} {...rest} />;
};

Copy.displayName = 'Copy';
